function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            @import url('https://fonts.googleapis.com/css?family=Merriweather+Sans');\r\n        "));
var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");
var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "svg-icon graphic",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: "svg-icon path",
  fillOpacity: 0,
  transform: "translate(2.12912048, 5.08058818)",
  d: "M2.42592142,3.08607074 C1.45331698,1.48142597 3.78002157,0 4.38789932,1.65225203 C5.42897742,4.47648282 7.10448412,12.12024882 3.32725743,17.31504122 C2.27360262,18.76286202 0,17.39205292 1.22274265,15.88262272 C3.12882377,13.53166412 8.43902042,9.06498272 15.46524902,9.33942462 C17.37133012,9.41223572 17.27351072,12.12584962 15.56726072,11.91721782 C12.80316362,11.57556572 6.66429682,10.07593692 2.42592142,3.08607074 Z",
  id: "PDF-icon",
  stroke: "#FFFFFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("text", {
  className: "svg-icon text",
  fontFamily: "'Merriweather Sans', sans-serif",
  fontSize: 12,
  fontWeight: "bold",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("tspan", {
  className: "svg-icon tspan",
  x: 33.1113281,
  y: 20
}, "PDF")));
function SvgPdfDownloadButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "70px",
    height: "30px",
    viewBox: "0 0 70 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "467DF9E4-E077-49B6-9AD3-7654876F16E2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDownloadButton);
export default __webpack_public_path__ + "static/media/PDF_download_button.2c832d64b3213daecd72957e398eeed7.svg";
export { ForwardRef as ReactComponent };